<template>
    <div class="side-function-bar-custom-fields side-function-bar-custom-fields--no-padding">
        <template v-if="!isLoading">
            <template v-if="fieldList.length === 0 && taskId">
                <p v-if="isTaskDone" class="side-function-bar-custom-fields__task-tip">
                    {{ $t('task.reviewSuccess') }}
                </p>
                <p v-else class="side-function-bar-custom-fields__task-tip">
                    {{ taskType === 1 ? $t('task.emptyField') : $t('task.emptyFieldNoButton') }}
                </p>
            </template>
            <template v-else>
                <CustomField
                    v-if="requestReady"
                    :activeTab="activeTab"
                    :patentId="patentId"
                    :fieldList="fieldList"
                    :pinnedFields="pinnedFields"
                    :spaceName="spaceName"
                    :spaceIcon="spaceIcon"
                    :folderName="folderName"
                    :spaceId="spaceId"
                    :spaceType="spaceType"
                    :canEdit="canEdit"
                    :folderId="folderId"
                    :currentFolder="currentFolder"
                    :taskId="taskId"
                    :isOwner="isOwner"
                    :savedInFolder="savedInFolder"
                    :customFieldsDisplay="customFieldsDisplay"
                />
            </template>
        </template>
        <custom-field-loading v-else />
    </div>
</template>

<script>
import { customFieldPolicyService } from '@analytics/shared/services/custom-field-policy-service';
import { Site, SLD } from '@patsnap-utils/biz';
import _ from 'lodash';
import CustomField from '../../../components/custom-field/fieldList';
import FieldService from '../../../services/field-service';
import { icons } from 'library-@/utils/workspaceIcon';
import CustomFieldLoading from '../../../components/custom-field/components/custom-field-loading';

export default {
    components: {
        CustomFieldLoading,
        CustomField,
    },
    props: {
        patentId: {
            type: String,
            required: true,
        },
        folderId: {
            type: String,
            required: true,
        },
        spaceId: {
            type: String,
            required: true,
        },
        wsViewType: {
            type: String,
        },
        isTaskDone: {
            type: Boolean,
            required: false,
        },
        isLoadingTask: {
            type: Boolean,
            required: false,
        },
        taskType: {
            type: Number,
            required: false,
        },
        taskId: {
            type: String,
            required: false,
        },
        taskFieldsList: {
            type: Array,
            required: false,
        },
        activeTab: {
            type: String,
            required: false,
        },
    },
    data() {
        return {
            customFieldUrl: new Site({ sld: SLD.WORKSPACE, pathname: 'customField' }).href,
            requestReady: false,
            fieldList: [],
            ///置顶的字段
            pinnedFields: [],
            spaceName: '',
            folderName: '',
            spaceIcon: '',
            spaceType: '',
            currentFolder: null,
            canEdit: false,
            canAdd: false,
            customFieldsDisplay: false,
            isOwner: '',
            savedInFolder: true,
        };
    },
    computed: {
        isLoading() {
            if (this.taskId) {
                return this.isLoadingTask;
            }
            return !this.requestReady;
        },
        selectedLength() {
            return _.filter(this.fieldList, item => !_.isEmpty(item.field_value)).length;
        },
    },
    watch: {
        selectedLength: {
            handler: function(val) {
                this.$emit('selectedLengthChange', val);
            },
            immediate: true,
        },
    },
    created() {
        this.getCustomFieldList();
    },
    methods: {
        async getCustomFieldList() {
            if (this.taskId) {
                this.fieldList = customFieldPolicyService.filterFields(this.taskFieldsList);
                this.requestReady = true;
                return;
            }
            const params = {
                spaceId: this.spaceId,
                folderId: this.folderId,
            };
            this.fieldService = new FieldService(this.patentId);
            if (this.spaceId && this.folderId) {
                params.isShared = true;
                params.wsViewType = this.wsViewType;
            } else {
                params.isShared = false;
            }
            try {
                const data = await this.fieldService.getFieldList(params);
                this.fieldList = customFieldPolicyService.filterFields(_.get(data, 'fieldObj.custom_fields', []));
                this.savedInFolder = _.get(data, 'fieldObj.saved_in_folder', true);
                this.pinnedFields = customFieldPolicyService.filterFieldIds(_.get(data, 'fieldObj.pinned_fields', []));
                this.spaceName = _.get(data, 'info.space_name', '');
                this.spaceType = _.get(data, 'info.space_type', '');
                this.isOwner = _.get(data, 'permission.is_owner', '');
                this.folderName = _.get(data, 'info.current_folder.folder_name', '');
                const spaceS3Key = _.get(data, 'info.space_s3_key', '');
                const spaceIcon = _.get(data, 'info.space_icon', '');
                if (spaceS3Key !== '' || spaceIcon !== '') {
                    this.spaceIcon = spaceS3Key || icons[spaceIcon];
                }
                this.currentFolder = _.get(data, 'info.current_folder');
                this.canEdit = _.get(data, 'permission.can_edit_fields');
                this.canAdd = _.get(data, 'permission.custom_fields_add', false);
                this.customFieldsDisplay = _.get(data, 'permission.custom_fields_display', false);
                this.requestReady = true;
            } catch (error) {
                this.fieldList = [];
                this.requestReady = false;
            }
        },
    },
};
</script>

<style lang="scss">
.side-function-bar-custom-fields {
    position: relative;
    height: 100%;
    padding: 8px 16px;

    &--no-padding {
        padding: 0;
    }

    &__section-title {
        margin-bottom: 12px;
        font-size: 14px;
        font-weight: 400;
        color: #495973;
        line-height: 20px;

        a {
            color: #1976d2;
            margin-top: 4px;
            display: block;
        }
    }

    &__task-tip {
        color: #b3bac5;
        font-size: 12px;
        text-align: center;
        padding: 160px 16px 0 16px;
    }

    &__mask {
        position: absolute;
        height: 100%;
        width: 100%;
        top: 0;
        left: 0;
        z-index: 9;
        background-color: transparent;
    }

    // 覆盖组件 CustomField 中的样式
    .custom-field .custom-field__list-small {
        height: 100%;
    }

    // 覆盖组件 CreateField 中的样式
    .create-field-modal {
        flex: 1;
        position: relative;

        .field-modal-body,
        .modal-form {
            height: 100%;
            position: relative;
        }

        .zen-form-group__btns {
            .pt-ui-btn[data-type=default] {
                display: none;
            }
        }
    }
}
//组件库样式覆盖
.custom-field-label-pane__layer-field-pane__popover {
    .field-editor-wrap-footer-comments .patsnap-biz-icon {
        margin-bottom: 0 !important;
    }
    .field-editor{
        box-shadow: none !important;
    }
}
</style>
